import React from "react";
import Header from "./Header";
import Footer from "./Footer";

export default function LegalPage({ title, children }) {
  return (
    <main>
      <Header />
      <section className="page-hero compact">
        <div className="site-container narrow">
          <span className="eyebrow light">Informação legal</span>
          <h1>{title}</h1>
          <p>Informação transparente sobre os serviços digitais do CENFOTEP.</p>
        </div>
      </section>
      <section className="section">
        <div className="site-container legal-copy">{children}</div>
      </section>
      <Footer />
    </main>
  );
}
